export const NO_DATA_AVAILABLE = {
	value: 'No data available',
	label: 'no_data_available',
}

export const DATE = {
	format: 'DD-MM-YYYY',
}
